import { app } from '../../../../bootstrap/core';
import { transferringCompletedState, transferringCompletedStateName, receivingCompletedState, receivingCompletedStateName } from './completed.state';
import { completedComponent } from './completed.component';

app.config(transferringCompletedState);
app.config(receivingCompletedState);
app.constant('transferringCompletedStateName', transferringCompletedStateName);
app.constant('receivingCompletedStateName', receivingCompletedStateName);
app.component(completedComponent.name, completedComponent);
